<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	padding:60px 15%;
	display:flex;
	.left
		width:900px;
		min-height 700px;
		margin-right:40px;
		position :relative;
		margin-bottom:50px;
		// float:left;
		.top
			display:flex;
			.top-r
				.top-title
					// height:42px;
					font-size:30px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:42px;
				.top-desc
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.4);
					line-height:20px;
					margin-top:10px;
					display:flex;
					span
						margin-right:25px;
					.share_style
						display: flex;
						align-items: center;
						.jtico
							display: block;
							width: 16px;
							height: 16px;
							margin-right: 4px;
							background: url(/static/img/share_ico.png) no-repeat left;
						.jtico_qzone
							background-position: 0px -64px;
						.jtico_tsina
							background-position: 0px -96px;
						.jtico_weixin
							background-position: 0px -1809px;
		.sel-body
			margin:42px 0px;
			min-height 500px;
			.text-summary-title
				height:22px;
				font-size:16px;
				font-weight:500;
				color:rgba(7,19,54,1);
				line-height:22px;
			.text-summary
				// height:30px;
				margin:10px 0 0 10px;
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,1);
				line-height:30px;
				white-space: pre-line;
				word-break: break-word;
				word-wrap: break-word;
				padding-bottom:20px;
				border-bottom:1px solid rgba(241,241,241,1);
			.text-content
				margin-top:27px;
		.statement
			border-top:1px solid rgba(241,241,241,1);
			padding-top:37px;
			position :absolute;
			bottom :0;
			left: 0;
			width:870px;
			height:48px;
			font-size:14px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:24px;
	.right
		width:400px;
		// float: right;
		.r-sign
			margin-left:30px;
			margin-top:30px;
			.r-s-title
				height:28px;
				font-size:20px;
				font-weight:500;
				color:rgba(7,19,54,1);
				line-height:28px;
			.course-list
				margin-top:10px;
				display:flex;
				flex-wrap: wrap;
				// width:1374px;
				// height:450px;
				.courseing
					box-shadow:0px 2px 27px 0px rgba(0,84,116,0.11);
					width: 348px;
					height: 150px;
					border-radius: 10px;
					margin: 10px 5px;
					display:flex;
					position: relative;
					cursor:pointer;
				  	.list-img
						width: 348px;
						height: 150px;
						border-radius: 10px;
				  	.course-lists
						margin-right: 24px;
						position: absolute;
						left: 115px;
						top:30px;
						.l-title
							height:42px;
							font-size:15px;
							font-weight:500;
							color:rgba(7,19,54,1);
							line-height:21px;
							overflow: hidden;
							display: -webkit-box;
							text-overflow:ellipsis;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						.l-name
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:7px;
						.l-time
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:2px;
						.l-btn
							display: flex;
							margin-top:6px;
							font-size:10px;
							font-weight:500;
							.l-type
								// width:71px;
								padding:0 10px;
								height:20px;
								line-height:20px;
								background:rgba(209,173,10,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
								margin-right:6px;
		  					.l-type-fldjt
								background-color: #5C607D;
		  					.l-type-no
								background-color: #A3AB5F;
		  					.l-sign
								width:50px;
								height:20px;
								line-height:20px;
								background:rgba(33,177,104,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
		  					.l-over
								background:rgba(185,185,185,1);
			.r-desc
				display:flex;
				align-items:center;
				justify-content:center;
				width:348px;
				height:114px;
				background:rgba(250,250,250,1);
				border-radius:12px;
				.r-d-img
					width:79px;
					height:79px;
					margin-left:9px;
				.r-d-info
					width:200px;
					height:78px;
					font-size:16px;
					font-weight:400;
					color:rgba(7,19,54,0.8);
					line-height:26px;
</style>
<style lang="stylus">

</style>

<template>
  	<div class="main">
  		<div class="left">
  			<goBack></goBack>
	    	<div class="top">
	    		<div class="top-r">
	    			<div class="top-title">{{post.title}}</div>
	    			<div class="top-desc">
	    				<span>作者： {{post.name}}</span>
	    				<span>更新：  {{post.time}}</span>
	    				<span>|</span>
	    				<span>赞  {{post.upvote_num}}</span>
	    				<span>收藏  {{post.collect_num}}</span>
	    				<span>浏览  {{post.pv_num}}</span>
	    				<span>|</span>
	    				<span class="share_style">
	    					分享&nbsp;&nbsp;
							<a @click="shareFn('qzone')" href="javascript:;" class="share_button_qzone" title="分享到QQ空间">
                                <span class="share_txt jtico jtico_qzone"></span>
                            </a>
                            <a @click="shareFn('sina')" href="javascript:;" class="share_button_tsina" title="分享到微博">
                                <span class="share_txt jtico jtico_tsina"></span>
                            </a>
                            <a @click="shareFn('weixin')" href="javascript:;" class="share_button_weixin" title="分享到微信">
                                <span class="share_txt jtico jtico_weixin"></span>
                            </a>
	    				</span>
	    			</div>
	    		</div>
	    	</div>
		    <div class="sel-body">
		    	<div class="text-summary-title">【摘要】</div>
		    	<div class="text-summary" v-html="post.summary"></div>
		    	<div id="text-content" class="text-content" v-html="post.content"></div>
		    </div>
		    <div class="statement">
		    	特别声明:   本平台对所有原创、转载、分享的内容、陈述、观点判断均保持中立，推送文章仅供读者参考。本平台发布的文章、图片等版权归作者所有，部分转载作品、图片如有作者来源标记有误或未做标记的，请原创作者友情提示并联系平台删除。
		    </div>
	    </div>
	    <div class="right">
	    	<div class="r-sign">
	    		<div class="r-s-title">评论（{{post.commentTotal}}）</div>
	    		<div class="comment_wrap">
                    <comment :id="pid" @changeCommentLength="changeCommentNum"></comment>
                </div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-s-title">推荐课程</div>
	    		<div class="course-list">
			    	<div v-if="!courseList.length" class="noList">暂时没有课程</div>
			    	<div v-else v-for="(item , index) in courseList" :key="index"  class="courseing" @click="$router.push({name: 'courseInfo', params: {course_id: item.id}})">
						<img :src="item.cover" class="list-img">
						<div class="course-lists">
							<div class="l-title">{{item.title}}</div>
							<div class="l-name">主讲人：{{item.speaker}}</div>
							<div class="l-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div>
							<div class="l-btn">
								<!-- <div class="l-type" v-if="item.catagory == '企业法务通'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-fldjt" v-else-if="item.catagory == '法律大讲堂'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-no" v-else>{{item.catagory}}</div> -->
								<div class="l-type">{{item.tag_name}}</div>
								<div v-if="item.issign" class="l-sign">报名中</div>
			        			<div v-else class="l-sign l-over">已结束</div>
							</div>
						</div>
			    	</div>
			    </div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-desc">
	    			<div class="r-d-info">扫码弘商小程序二维码，随时关注课程信息，快速报名课程哦</div>
	    			<img src="/static/img/wechat.png" class="r-d-img">
	    		</div>
	    	</div>
	    </div>

	    <Modal
            v-model="qrcodeBox"
            title="分享到微信">
            <div id="qrcode" ref="qrcode" style="text-align: center; width: 130px; margin: 0 auto"></div>
            <div slot="footer"></div>
        </Modal>
  	</div>
</template>

<script>
import moment from 'moment';
import Viewer from 'viewerjs'
import comment from '@/components/post/z-comment'
import goBack from '@/components/common/goBack';
export default {
  	name: 'Post',
  	data () {
    	return {
      		pid:'',
      		post:{
      			title:'疫情下合同如何履约，如何主张不可抗力免责',
      			name:'弘商管家',
      			time:'2019-11-27 11:25',
      			upvote_num:289,
      			collect_num:289,
      			pv_num:289,
      			summary:'<p>这是摘要</p><p>测试<br/><p>',
      			content:'<p>测试<br/></p>'
      		},
            courseList:[],
            qrcodeBox:false
    	}
  	},
  	components: {comment,goBack},
  	computed:{
	    loginStatus() {
	      return this.$store.state.loginStatus;
	    },
	},
  	created() {
    	this.pid = Number(this.$route.params.post_id);
	},
	mounted(){
		this.getInfo()
		this.getCourse();
	},
	methods:{
		//获取知识详情
		getInfo(){
			var url = 'post/info/' + this.pid;
	  		this.$http.get(url).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				// console.log('12',res);
	  				res.data.data.content = res.data.data.content.replace(/http:\/\/honsenflagstorage[.]oss/g,"https://honsenflagstorage.oss");
	  				//最老的上传文件，直接用a标签加href，有http地址的，谷歌浏览器在https域名下不能下载http文件。
	  				this.post = res.data.data;
	  				this.$nextTick(() => {
	                    this.prettyFileCss();
	                });
	  			}
	  		})
		},
		prettyFileCss() {
            let fTypes = ['avi','doc','jpg','png','mp3','pdf','ppt','rar','xls','docx','pptx','xlsx','txt','chm'];
            let canPreviwe = ['doc','ppt','xls'];
            let contentDom = document.querySelector('#text-content');

            if (!contentDom) {
                return false;
            }

            /* 原来的上传文件 */
            let elements1 = contentDom.querySelectorAll('.ck_file');
            if(elements1.length){
                Array.prototype.forEach.call(elements1,function(el) {
                    let fUrl = el.getAttribute('href');

                    el.className = 'ueditor_file';
                    el.setAttribute('href','//office.honsenflag.com/op/view.aspx?src=' + fUrl);
                    el.setAttribute('target','_blank');

                    let fType = el.getAttribute('data-type');
                    if(fType == 'docx' || fType == 'pptx' || fType == 'xlsx'){
                        fType = fType.substring(0,3);
                    }

                    let oldText = el.innerText.trim();

                    if(fTypes.indexOf(fType) != -1){
                        el.innerHTML = `<img src="/static/img/format/${fType}.jpg" class="icon_img" width="18" height="18">${oldText}<a class="f_downLoad" href="${fUrl}"><div class="icon_xiazai"></div></a>`;
                    }else {
                        el.innerHTML = `${oldText}<a class="f_downLoad" href="${fUrl}"><div class="icon_xiazai"></div></a>`;
                    }
                });
            }
            /* 新上传的文件class="ck_file_2" */
            let elements = contentDom.querySelectorAll('.ck_file_2');
            if(elements.length){
                Array.prototype.forEach.call(elements,function(el) {
                    el.className = 'ueditor_file';
                    let hash = el.getAttribute('data-hash');
                    let oldText = el.innerText.trim();
                    let fType = oldText.split('.').pop();
                    if(fType == 'docx' || fType == 'pptx' || fType == 'xlsx'){
                        fType = fType.substring(0,3);
                    }
                    if(fTypes.indexOf(fType) != -1){
                        if(canPreviwe.indexOf(fType) != -1){
                            el.setAttribute('href',`${imgUrl}/file/preview/${hash}`);
                        }else{
                            el.setAttribute('href',`${imgUrl}/file/download/${hash}`);
                        }
                        el.innerHTML = `<img src="/static/img/format/${fType}.jpg" class="icon_img" width="18" height="18">${oldText}<a class="f_downLoad" href="${imgUrl}/file/download/${hash}"><div class="icon_xiazai"></div></a>`;
                    }else {
                        el.setAttribute('href',`${imgUrl}/file/download/${hash}`);
                        el.innerHTML = `${oldText}<a class="f_downLoad" href="${imgUrl}/file/download/${hash}"><div class="icon_xiazai"></div></a>`;
                    }
                });
            }

            /* ueditor上传的 */
            let els_ue = contentDom.querySelectorAll('.ueditor_file');
            if(els_ue.length){
                Array.prototype.forEach.call(els_ue,function(el) {

                    // 如果里面有图片就拿出图片 否则会不显示
                    if( el.querySelector('.ueditor_img') ){
                        el.parentNode.replaceChild(el.querySelector('.ueditor_img'), el);
                        return false;
                    }

                    // 移除firefox下编辑器enter生成的空a标签
                    if (!el.innerText.replace(/\s/, '')) {
                        el.parentNode.removeChild(el);
                        return false;
                    }


                    let hash = el.getAttribute('data_hash') || el.getAttribute('data-hash');
                    let oldText = el.innerText.trim();
                    let fType = oldText.split('.').pop().toLowerCase();

                    if(fType == 'docx' || fType == 'pptx' || fType == 'xlsx'){
                        fType = fType.substring(0,3);
                    }

                    if(canPreviwe.includes(fType)) {
                        el.setAttribute('href',`${imgUrl}/file/preview/${hash}`);
                    } else {
                        el.setAttribute('href',`${imgUrl}/file/download/${hash}`);
                    }

                    let icon_fType = fTypes.includes(fType)? fType: 'noa'; /* noa通用文件类型的图标 */
                    el.innerHTML = `<img src="/static/img/format/${icon_fType}.jpg" class="icon_img" width="18" height="18">
                                    ${oldText}
                                    <a class="f_downLoad" href="${imgUrl}/file/download/${hash}" target="_blank"></a>`;
                });
            }

            /* 图片预览 */
            let ue_imgs = contentDom.querySelectorAll('.ueditor_img');
            if(ue_imgs.length){
                Array.prototype.forEach.call(ue_imgs,function(el) {
                    new Viewer(el,{navbar: false, toolbar: false});
                });
            }

        },
		//获取推荐课程
		getCourse(){
	  		let url = 'wxm/course/index';
	  		let param = {
	  			page:1,
	  			per_page:10
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				var datas = res.data.data.data.slice(0,2);//只去前2条数据，由于排序要求不用分页per_page=3处理。
	  				var timestamp = Date.parse(new Date());
	        		timestamp = timestamp / 1000;
	        		for(var i = 0 ; i <datas.length ; i++){
			          datas[i].start_time = moment(datas[i].start_time * 1000).format("YYYY-MM-DD HH:mm");
			          if (datas[i].end_time > timestamp){
			            datas[i].issign = true;
			          }else{
			            datas[i].issign = false;
			          };
			          datas[i].end_timehm = moment(datas[i].end_time * 1000).format("HH:mm");
			        };
			        this.courseList = datas;
	  			}
	  		})
	  	},
	  	changeCommentNum(obj) {
            this.post.commentTotal = obj.total;
        },
	  	//分享
	  	shareFn(name) {
            switch(name) {
                case 'qzone':
                    window.open('//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + window.location.href + '&title=' + this.post.title + '&summary=' + this.post.summary + '&site=' + this.post.title);
                    break;
                case 'sina':
                    window.open('//service.weibo.com/share/share.php?url=' + window.location.href + '&title=' + this.post.title + '&summary=' + this.post.summary + '&site=' + this.post.title);
                    break;
                case 'weixin':
                    this.qrcodeBox = true
                    break;
            }
        },
	},
	watch:{
		$route(to,from){
		    this.pid = to.params.post_id;
		    this.getInfo();
			this.getCourse();
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/post/index.vue